// extracted by mini-css-extract-plugin
export default {"inputs":"IdDocumentForm_inputs__cY3i5","fileUpload":"IdDocumentForm_fileUpload__OlsVC"};